<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mb-3">
          <vs-input :label="$t('queue_status_call_id_sequence')" disabled :placeholder="$t('queue_status_call_id_sequence')" v-model="callidSequence" class="w-full"/>
        </div>
        <div class="mb-3">
          <vs-input :label="$t('queue_status_service_name')" disabled :placeholder="$t('queue_status_service_name')" v-model="serviceName" class="w-full"/>
        </div>
        <div class="mb-3">
          <vs-input :label="$t('queue_status_caller_id')" disabled :placeholder="$t('queue_status_caller_id')" v-model="callerId" class="w-full"/>
        </div>
        <h4 v-text="$t('users')" class="mb-3" />
        <div v-for="(user, key) in users" v-bind:key="'caller_id_users_' + key" class="mb-3">
          <vs-checkbox v-value="user.id" v-model="user.selected">{{ user.label}}</vs-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { EventBus } from '@/../eventbus'
import CallerId from '@/models/CallerId'

export default {
  name: 'SharedCallerIdEditUsers',
  data () {
    return {
      id: '',
      callidSequence: '',
      serviceName: '',
      callerId: '',
      users: []
    }
  },
  mounted () {
    EventBus.$on('initCallerIdGetFormData', (data) => {
      this.id = data.id
      this.editCallerIdUsers()
    })
    EventBus.$on('updateCallerIdUsers', () => {
      this.updateCallerIdUsers()
    })
  },
  methods: {
    async editCallerIdUsers () {
      try {
        const response = await CallerId.editUsers({ id: this.id })
        this.users = response.data.users
        this.callidSequence = response.data.callidSequence
        this.serviceName = response.data.serviceName
        this.callerId = response.data.callerId
      } catch (e) {
        this.$swalHelper.error({
          title: '',
          text: e.response.data,
          confirmButton: this.$t('confirm')
        })
      }
    },
    async updateCallerIdUsers () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#editCallerIdUserButton', scale: 0.45})
      try {
        if (!this.$store.getters.isFormInProgress) {
          this.$store.dispatch('setIsFormInProgress', true)
          const response = await CallerId.updateUsers({ id: this.id, users: this.users })
          this.$emit('editCallerIdUsersSuccess', response)
          this.$store.dispatch('setIsFormInProgress', false)
        }
      } catch (e) {
        this.$swalHelper.error({
          title: '',
          text: e.response.data.message,
          confirmButton: this.$t('confirm')
        })
        this.$store.dispatch('setIsFormInProgress', false)
      }
      this.$vs.loading.close('#editCallerIdUserButton > .con-vs-loading')
    }
  }
}
</script>

<style lang="scss">
#editCallerIdUserButton {
  .con-vs-loading {
    position: absolute !important;
  }
}
</style>
